import React from 'react'
import * as firebase from 'firebase';
import FirebaseConfig from '../components/config';


export const app = firebase.initializeApp(FirebaseConfig);

export const SecondApp = firebase.initializeApp(FirebaseConfig, "Secondary");